import React from 'react';
import PropTypes from 'prop-types';
import Slider from 'react-slick';

const TestimonialNextArrow = ({ className, onClick }) => (
  <div
    className={className}
    onClick={onClick}
    onKeyDown={onClick}
    role="button"
    tabIndex="0">
    <img src="/img/arrow.svg" alt="next arrow" />
  </div>
);

TestimonialNextArrow.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func,
};

const TestimonialPrevArrow = ({ className, onClick }) => (
  <div
    className={className}
    onClick={onClick}
    onKeyDown={onClick}
    role="button"
    tabIndex="0">
    <img src="/img/arrow.svg" alt="prev arrow" />
  </div>
);

TestimonialPrevArrow.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func,
};

const Testimonial = () => {
  const settings = {
    dots: true,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 5000,
    speed: 1100,
    slidesToShow: 1,
    slidesToScroll: 1,
    nextArrow: <TestimonialNextArrow />,
    prevArrow: <TestimonialPrevArrow />,
    responsive: [
      {
        breakpoint: 990,
        settings: {
          dots: false,
        },
      },
    ],
  };

  return (
    <section className="testimonial-main">
      <div className="container">
        <div className="testimonial-block">
          <Slider {...settings}>
            <div>
              <div className="single-testimonial">
                <img src="/img/stars.svg" alt="5 stars" />
                <h3>
                  “ All of our verticals at Lodha currently have one source of
                  truth and it’s Powerplay.”
                </h3>
                <div className="testimonial-author">
                  <img
                    src="/img/managing-director.png"
                    alt="Rishabh Tiwari, MD @ Lodha Pvt Ldt."
                  />
                  <p>Rishabh Tiwari, MD @ Lodha Pvt Ldt.</p>
                </div>
              </div>
            </div>
            <div>
              <div className="single-testimonial">
                <img src="/img/stars.svg" alt="5 stars" />
                <h3>
                  “ All of our verticals at Lodha currently have one source of
                  truth and it’s Powerplay.”
                </h3>
                <div className="testimonial-author">
                  <img
                    src="/img/managing-director.png"
                    alt="Rishabh Tiwari, MD @ Lodha Pvt Ldt."
                  />
                  <p>Rishabh Tiwari, MD @ Lodha Pvt Ldt.</p>
                </div>
              </div>
            </div>
            <div>
              <div className="single-testimonial">
                <img src="/img/stars.svg" alt="5 stars" />
                <h3>
                  “ All of our verticals at Lodha currently have one source of
                  truth and it’s Powerplay.”
                </h3>
                <div className="testimonial-author">
                  <img
                    src="/img/managing-director.png"
                    alt="Rishabh Tiwari, MD @ Lodha Pvt Ldt."
                  />
                  <p>Rishabh Tiwari, MD @ Lodha Pvt Ldt.</p>
                </div>
              </div>
            </div>
            <div>
              <div className="single-testimonial">
                <img src="/img/stars.svg" alt="5 stars" />
                <h3>
                  “ All of our verticals at Lodha currently have one source of
                  truth and it’s Powerplay.”
                </h3>
                <div className="testimonial-author">
                  <img
                    src="/img/managing-director.png"
                    alt="Rishabh Tiwari, MD @ Lodha Pvt Ldt."
                  />
                  <p>Rishabh Tiwari, MD @ Lodha Pvt Ldt.</p>
                </div>
              </div>
            </div>
          </Slider>
        </div>
      </div>
    </section>
  );
};

export default Testimonial;
